module.exports = __webpack_public_path__ + "static/media/dinheiro.8bd838bb.svg";